import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { UserAccessors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/user.selector';
import { useHostSelector } from '../store';

const useHomePageRedirectWatcher = () => {
  const homePageUri = useHostSelector(UserAccessors.getUserHomePage);
  const navigate = useNavigate();

  useEffect(() => {
    if (homePageUri) {
      navigate(homePageUri, { replace: true });
    }
  }, [homePageUri]);
};

export default useHomePageRedirectWatcher;
